// 장비·자산·라이선스 관리 — WorkAssets/assets.json 한 파일(관리자만 수정). 카드번호·라이선스 키 같은 비밀값은 저장하지 않는다.
export const ASSET_CATEGORIES = ['노트북', '모니터', '데스크톱', '휴대폰', '법인카드', '소프트웨어 라이선스', '기타'];
/** 만료까지 남은 일수(KST 날짜 기준), 만료일 없으면 null */
export function daysUntil(date, today) {
    if (!date)
        return null;
    return Math.round((Date.parse(`${date}T00:00:00Z`) - Date.parse(`${today}T00:00:00Z`)) / 86_400_000);
}
export const EXPIRY_WARN_DAYS = 30;
// 칭찬·감사 카드 — Kudos/<YYYY-MM>.json 월별 파일(전원 작성)
export const KUDOS_EMOJIS = ['👏', '🙏', '💪', '🎉', '🌟', '☕'];
export const KUDOS_MAX = 200;
//# sourceMappingURL=assets.js.map